import { render, staticRenderFns } from "./LgsUploadAttach.vue?vue&type=template&id=36c48f93&scoped=true&"
import script from "./LgsUploadAttach.vue?vue&type=script&lang=js&"
export * from "./LgsUploadAttach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c48f93",
  null
  
)

export default component.exports